<template>
  <div class="formData payment_record">
    <FormBox
      :title="$t('message.DataRegistration.International.checkRecordTitle')"
    >
      <template slot="right">
        <el-button
          type="primary"
          plain
          @click="$router.push('/international')"
          >{{ $t("message.back") }}</el-button
        >
      </template>
      <el-table :data="showAll ? data : data.slice(0, 5)" v-loading="loading">
        <!-- 國際駕照編號 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.licenseNo')"
          prop="licNo"
        ></el-table-column>
        <!-- 發出日期 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.createDay')"
          prop="createDay"
        >
        </el-table-column>
        <!-- 有效日期 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.expiryDate')"
          prop="expiryDate"
        >
        </el-table-column>
        <!-- 個案查詢編號 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.spNo')"
          prop="spNo"
        ></el-table-column>
        <!-- 申請途徑 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.zoneName')"
          :prop="`zoneName${$t('message.lan')}`"
        >
        </el-table-column>
        <!-- 狀態 -->
        <el-table-column
          :label="$t('message.statusZ')"
          :prop="`describe${$t('message.lan')}`"
        ></el-table-column>
        <!-- 申請日期 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.applyDate')"
          prop="applyDate"
        >
        </el-table-column>
        <!-- 領取日期 -->
        <el-table-column
          :label="$t('message.DataRegistration.International.sendDate')"
          prop="sendDate"
        >
        </el-table-column>
      </el-table>
    </FormBox>
    <div v-if="!showAll && data.length > 5" class="showMore">
      <span @click="showAllData">{{
        $t("message.DataRegistration.Taxi.showAll")
      }}</span>
    </div>
  </div>
</template>

<script>
import FormBox from "../components/FormBox";
import DrivIntApplicationAPI from "../../../../api/DrivIntApplicationAPI";
export default {
  components: { FormBox },
  data() {
    return {
      loading: false,
      showAll: false,
      data: [],
    };
  },
  methods: {
    showAllData() {
      this.showAll = true;
    },
    get() {
      const serviceType = this.$route.meta.type;
      const verifyForm = this.$store.state.verifyForm;
      const identType = verifyForm.identType;
      const identNo = verifyForm.identNo;
      this.loading = true;
      DrivIntApplicationAPI.history(serviceType, identType, identNo)
        .then((res) => {
          this.loading = false;
          this.data = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    this.get();
  },
};
</script>

<style lang="scss" scoped>
.formData {
  overflow: hidden;
  max-width: 1048px;
  margin: auto;
  box-shadow: 0px 2px 7px 2px rgba(0, 0, 0, 0.16);
}
.payment_record {
  min-height: 800px;
  /deep/.el-table {
    margin: 30px 0;
    table {
      min-width: 530px;
      width: 100% !important;
    }
  }
  /deep/.el-table th {
    background: #5ba7ad;
    color: #fff;
    font-size: 16px;
    text-align: center;
  }

  /deep/.el-table--enable-row-transition .el-table__body td {
    text-align: center;
    font-size: 16px;
  }
}
.showMore {
  text-align: center;
}
.showMore span {
  display: inline-block;
  color: #5ba7ad;
  font-size: 18px;
  padding: 10px;
  border-top: 1px solid #5ba7ad;
  cursor: pointer;
}
</style>